module.exports = __webpack_public_path__ + "static/media/dma_stakeholder.95cee719.svg";